module.exports = __webpack_public_path__ + "static/img/4.25f18a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feedbacks/4.jpg
// module id = UXgR
// module chunks = 0